<template scoped>
  <b-modal
    v-model="trigger"
    :id="id"
    :ok-title="okTitle"
    :title="title"
    @ok="eventOk($event)"
    @cancel="eventCancel($event)"
    :centered="centered"
    :no-close-on-backdrop="dontCloseWhenClickedOutside"
    :no-close-on-esc="dontCloseWhenEscapePressed"
    :hide-header-close="dontShowCloseIcon"
    :ok-only="okOnly"
    :header-bg-variant="headerBgVariant"
  >
    <div class="m-3 p-0">
      <span v-if="title == 'Alert'">
        <img class="green-tick" src="@/assets/alert.png" />
      </span>
      <span
        v-if="title == 'Success!' || title == 'Added Successfully' || title ==  'Partner Portal' || title ==  'Saved Successfully'"
      >
        <img class="green-tick" src="@/assets/Approve-tick-mark.svg" />
      </span>

      <p class="m-0 p-3 successText">{{text}}</p>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: [
    "trigger",
    "text",
    "okTitle",
    "okOnly",
    "id",
    "title",
    "centered",
    "dontCloseWhenClickedOutside",
    "dontCloseWhenEscapePressed",
    "dontShowCloseIcon"
  ],
  data() {
    return {
      show: false,
      headerBgVariant: "bg-headerModule",
      headerTextVariant: "light",
      footerBgVariant: "warning",
      footerTextVariant: "dark"
    };
  },
  methods: {
    eventOk(event) {
      this.$emit("eventOk", event);
    },
    eventCancel(event) {
      this.$emit("eventCancel", event);
    }
  }
};
</script>

<style scoped>
modal-body {
  padding: 0% !important;
}
.modal-footer {
  padding: 2% !important;
}
.green-tick {
  height: 8vh !important;
  display: block;
  margin-left: auto !important;
  margin-right: auto !important;
}
.successText {
  text-align: center;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.25;
  color: #333333;
}
</style>
<style>
.modal-header {
  font-family: "Source Sans Pro", sans-serif;
  padding: 2% !important;
  color: white;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.modal-footer {
  padding: 8px;
  margin-left: 4%;
  margin-right: 5%;
  border-top: 1px solid #dee2e6;
  font-family: "Source Sans Pro", sans-serif;
}
.modal-footer > .btn-primary {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: white;
  border-radius: 2px;
  background-color: #1579ab;
}
.modal-footer > .btn-secondary {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: black;
  border-radius: 2px;
  background-color: white;
}
</style>
